import { Tooltip } from 'react-bootstrap';

export const NewAssignmentsTooltip = (
    <Tooltip id='tt-new-assignments'>
        Patients assigned to a coach during the month.
    </Tooltip>
);

export const TotalActivePatientsTooltip = (
    <Tooltip id='tt-active-patients'>
        Patients actively being worked with by this coach at month-end. Must be assigned, not deactivated, not hidden from the coach, and have a coaching status of In Process, Contact Attempted, Contact Made, or Received Voucher. Includes both Starter and Custom Site patients.
    </Tooltip>
);

export const ActiveCustomSitesTooltip = (
    <Tooltip id='tt-custom-sites'>
        Patients with an active Custom Microsite assigned to this coach at month-end who have not been deactivated.
    </Tooltip>
);

export const ActiveStarterSitesTooltip = (
    <Tooltip id='tt-starter-sites'>
        Patients with an active Starter Microsite assigned to this coach at month-end who have not been deactivated.
    </Tooltip>
);

export const NewInactiveTooltip = (
    <Tooltip id='tt-new-inactive'>
        Patients whose microsite was deactivated during the month.
    </Tooltip>
);

export const LivingDonorTxTooltip = (
    <Tooltip id='tt-ld-tx'>
        Patients with a Living Donor Transplant or Living Donor Transplant (From Other Center) event recorded during the month. A patient is counted once per month regardless of how many events are logged.
    </Tooltip>
);

export const NewMsRegistrationTooltip = (
    <Tooltip id='tt-ms-registration'>
        Total new microsite patient registrations across all coaches for the month, including patients not yet assigned to a coach.
    </Tooltip>
);

export const OptInPercentTooltip = (
    <Tooltip id='tt-opt-in'>
        The share of newly registered patients who requested coaching when they signed up. Calculated as coaching opt-ins divided by total new registrations for the month.
    </Tooltip>
);
